import React from 'react';
import { joinValidStrings } from '../utils/string';
import { formatPublication } from '../utils/format-publication-data';

export default function PublicationData({ doc, doc: { publisher } }) {
  // 'Source, vol. X, issue Y (Year) pp. A-B Published by Z'
  const publicationString = joinValidStrings([
    formatPublication(doc),
    publisher && `Published by ${publisher}`
  ], ' ');

  return publicationString
    ? <p className="publisher" data-name="publisher">{ publicationString }</p>
    : null;
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/PublicationData.js